import {
    AG_GRID_LOCALE_DE,
    AG_GRID_LOCALE_EN,
    AG_GRID_LOCALE_ES,
    AG_GRID_LOCALE_FR,
} from '@ag-grid-community/locale';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class AgGridTranslationService {
    constructor(private translate: TranslateService) {}

    public getAgGridTranslations() {
        switch (this.translate.currentLang) {
            case 'fr':
                return AG_GRID_LOCALE_FR;
            case 'de':
                return AG_GRID_LOCALE_DE;
            case 'es':
                return AG_GRID_LOCALE_ES;
            default:
                return AG_GRID_LOCALE_EN;
        }
    }
}
